import Button from '@jetbrains/ring-ui/components/button/button'
import type {DialogAttrs} from '@jetbrains/ring-ui/components/dialog/dialog'
import Input, {Size} from '@jetbrains/ring-ui/components/input/input'
import {Content, Header} from '@jetbrains/ring-ui/components/island/island'
import Panel from '@jetbrains/ring-ui/components/panel/panel'
import {useState} from 'react'
import {useNavigate} from 'react-router-dom'

import {useAppDispatch} from '../../../../../../../../../../hooks/react-redux'
import {getPipelinesHref} from '../../../../../../../../../../routes'
import {usePipelineNameOrDraft} from '../../../../../../../EditPipelinePage/EditPipelinePage.hooks'
import {pipelineError} from '../../../../../../../EditPipelinePage/slices/EditPipelinePage.slices'
import {usePipelineId} from '../../../../../../../hooks/pipeline'
import {pipelinesApi} from '../../../../../../../services/pipelinesApi'
import PipelineDialog from '../../../../../PipelineDialog/PipelineDialog'

import styles from './DeletePipelineDialog.css'

export function DeletePipelineDialog(props: DialogAttrs) {
  const [value, setValue] = useState('')
  const dispatch = useAppDispatch()
  const [deletePipeline] = pipelinesApi.endpoints.deletePipeline.useMutation()
  const id = usePipelineId()
  const name = usePipelineNameOrDraft()
  const navigate = useNavigate()
  const handlerConfirmDeletePipelineButtonClick = () => {
    deletePipeline(id).then(() => {
      dispatch(pipelineError.actions.resetError())
      navigate(getPipelinesHref())
    })
  }

  return (
    <PipelineDialog {...props}>
      <Header>{`Delete pipeline ${name}`}</Header>
      <Content>
        {'This action cannot be undone. Please type '}
        <strong>{location.host}</strong>
        {' to confirm'}
        <Input
          size={Size.FULL}
          className={styles.hostnameInput}
          placeholder={'Server hostname'}
          value={value}
          onChange={e => setValue(e.currentTarget.value)}
        />
      </Content>
      <Panel>
        <Button
          primary
          onClick={handlerConfirmDeletePipelineButtonClick}
          disabled={value !== location.host}
        >
          {'Delete'}
        </Button>
        <Button onClick={props.onCloseAttempt}>{'Cancel'}</Button>
      </Panel>
    </PipelineDialog>
  )
}
